var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanvas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5833 0H0V15.5833H15.5833V0ZM11.8485 1.41667L3.15532 10.1099L5.47351 12.428L14.1667 3.73482L11.8485 1.41667ZM2.57578 10.6894L1.41667 14.1667L4.89397 13.0076L2.57578 10.6894Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4906 6.13889H19.7747V12.2778C19.7747 13.0602 20.3826 13.6944 21.1326 13.6944C21.8826 13.6944 22.4906 13.0602 22.4906 12.2778V6.13889Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5833 0H17V15.5833H32.5833V0ZM23.8486 1.41667H18.4167V2.36111H19.322V12.2778C19.322 13.321 20.1326 14.1667 21.1326 14.1667C22.1326 14.1667 22.9433 13.321 22.9433 12.2778V2.36111H23.8486V1.41667ZM24.7539 3.54167H31.1667V4.87963H24.7539V3.54167ZM24.7539 6.21759H31.1667V7.55556H24.7539V6.21759ZM24.7539 8.89352H31.1667V10.2315H24.7539V8.89352ZM24.7539 11.5694H31.1667V12.9074H24.7539V11.5694Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5807 22.7995C11.2409 22.7995 11.776 22.2643 11.776 21.6042C11.776 20.944 11.2409 20.4089 10.5807 20.4089C9.92057 20.4089 9.38542 20.944 9.38542 21.6042C9.38542 22.2643 9.92057 22.7995 10.5807 22.7995Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.57576 18.9962C2.28598 18.9962 1.99621 19.286 1.99621 19.5758V30.0076C1.99621 30.2973 2.28598 30.5871 2.57576 30.5871H13.0076C13.2973 30.5871 13.5871 30.2973 13.5871 30.0076V19.5758C13.5871 19.286 13.2973 18.9962 13.0076 18.9962H2.57576ZM13.0076 20.1553V28.2689L9.5303 24.7917L8.37121 25.9508L6.63258 23.6326L2.57576 28.2689V20.1553C2.57576 19.8655 2.86553 19.5758 3.1553 19.5758H12.428C12.7178 19.5758 13.0076 19.8655 13.0076 20.1553Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5833 17H0V32.5833H15.5833V17ZM1.41667 19.612C1.41667 18.9962 1.989 18.4167 2.57576 18.4167H13.0076C13.5943 18.4167 14.1667 18.9962 14.1667 19.5758V30.0076C14.1667 30.5944 13.5871 31.1667 13.0076 31.1667H2.57576C1.99621 31.1667 1.41667 30.5944 1.41667 30.0076V19.612Z",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 21.25V24.0833H21.25V21.25H28.3333Z",
    fill: "current"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5833 17H17V32.5833H32.5833V17ZM28.3333 19.8333H21.25V21.25H19.8333V24.0833H21.25V25.5H28.3333V28.3333H21.25V26.9167H19.8333V28.3333H21.25V29.75H28.3333V28.3333H29.75V21.25H28.3333V19.8333Z",
    fill: "current"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.41667 32.5833H32.5833V34H1.41667V32.5833Z",
    fill: "current"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5833 1.41667H34V34H32.5833V1.41667Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvas);
export default __webpack_public_path__ + "static/media/Canvas.8e66d6d0f77e09244ac0550f1ce890ae.svg";
export { ForwardRef as ReactComponent };